import { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';

/**
 * Componente TabPanel
 *
 * Panel de contenido para tabs, muestra el contenido según el tab activo.
 *
 * @component
 * @param {object} props - Props del componente.
 * @param {React.ReactNode} [props.children] - Contenido del panel.
 * @param {number} props.index - Índice del panel.
 * @param {number} props.value - Índice del tab activo.
 * @param {string} [props.prefix] - Prefijo para los IDs de accesibilidad.
 * @param {SxProps<Theme>} [props.sx] - Estilos personalizados.
 * @example
 * <TabPanel value={0} index={0}>Contenido</TabPanel>
 */

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  prefix?: string;
  sx?: SxProps<Theme>;
}

export function TabPanel({
  children,
  value,
  index,
  prefix = 'simple',
  sx = {},
  ...other
}: TabPanelProps) {
  return (
    <Box
      aria-labelledby={`${prefix}-tab-${index}`}
      hidden={value !== index}
      id={`${prefix}-tabpanel-${index}`}
      role="tabpanel"
      sx={sx}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default TabPanel;
